export function arrayEquals<T>(arr1: T[] | undefined, arr2: T[] | undefined): boolean {
  if (arr1 == null && arr2 == null) {
    return true;
  }

  if (arr1 == null || arr2 == null) {
    return false;
  }

  const len = arr1.length;
  if (arr2.length !== len) {
    return false;
  }
  for (let i = 0; i < len; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
}

export function arrayContains<T>(arr: T[] | undefined, items: T[] | undefined): boolean {
  if (arr == null) {
    arr = [];
  }
  if (items == null) {
    items = [];
  }

  for (let i = 0, len = items.length; i < len; i++) {
    if (arr.indexOf(items[i]) < 0) {
      return false;
    }
  }
  return true;
}
